import { z } from "zod"

export const ChatMessageSchema = z.object({
  message: z.string(),
})

export type ChatMessage = z.infer<typeof ChatMessageSchema>
